import React, { useState } from 'react';
import { Dialog } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../util/auth';
import { addSeenShowNote } from '../util/db';

function SeenNoteModal({ showId, initialNote = '', onClose, onSaved }) {
  const auth = useAuth();
  const [note, setNote] = useState(initialNote);
  const [pending, setPending] = useState(false);

  const save = async () => {
    setPending(true);
    try {
      await addSeenShowNote(auth.user.id, showId, note.trim());
      onSaved?.(note.trim());
      onClose();
    } catch (error) {
      console.error(error);
      setPending(false);
    }
  };

  return (
    <Dialog open onClose={onClose} className="fixed inset-0 z-[200] flex items-center justify-center p-4">
      <div className="fixed inset-0 bg-black/50" aria-hidden="true" />
      <Dialog.Panel className="relative w-full max-w-md rounded-2xl bg-white p-6 shadow-xl">
        <button type="button" className="absolute right-4 top-4" onClick={onClose} aria-label="Close">
          <XMarkIcon className="w-5" />
        </button>
        <Dialog.Title className="text-lg font-medium uppercase">Add a note</Dialog.Title>
        <p className="mt-1 text-sm text-slate-500">What stood out? Notes appear on your seen shows.</p>
        <textarea
          className="mt-4 h-32 w-full rounded-lg border border-slate-300 p-3 font-oswald text-sm focus:outline-none"
          value={note}
          maxLength={1000}
          onChange={e => setNote(e.target.value)}
          autoFocus
        />
        <div className="mt-4 flex justify-end gap-2">
          <button type="button" className="btn btn-ghost btn-sm" onClick={onClose}>
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-sm bg-secondary-red text-white"
            disabled={pending}
            onClick={save}
          >
            {pending ? '...' : 'Save note'}
          </button>
        </div>
      </Dialog.Panel>
    </Dialog>
  );
}

export default SeenNoteModal;
